import { useUserStore } from "@/stores/user";

export default function name(zh,en) {
    if (useUserStore().language == 'zh-CN') {
        return zh
    }else{
        return en
    }
}